import { render, staticRenderFns } from "./BatchBooking.vue?vue&type=template&id=64eb0fbd&scoped=true&"
import script from "./BatchBooking.vue?vue&type=script&lang=js&"
export * from "./BatchBooking.vue?vue&type=script&lang=js&"
import style0 from "./BatchBooking.vue?vue&type=style&index=0&id=64eb0fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb0fbd",
  null
  
)

export default component.exports